/* eslint-disable no-useless-escape */
import { getPaths, getTenantId, getTenantDir } from "../plugins/env"
// 默认加上 www 为前缀
const canonicalizeUrl = url => {
  if (url.includes("wellcome.com.hk") && !url.includes("://www.")) {
    return url.replace("://", "://www.")
  }
  return url
}

export const getHeadMeta = item => {
  const fullPath = item.fullPath || ""
  const { MAIN_ORIGIN } = getPaths()
  const url = canonicalizeUrl(MAIN_ORIGIN + fullPath)
  return [{ name: "og:url", content: url }]
}

export const getHeadLink = item => {
  const { VUE_APP_PUBLIC_PATH } = process.env
  const fullPath = item.fullPath || ""
  const { MAIN_ORIGIN } = getPaths()
  const url = canonicalizeUrl(MAIN_ORIGIN + fullPath)
  const tenantId = getTenantId()
  return [
    {
      rel: "icon",
      href: `${VUE_APP_PUBLIC_PATH}/public/${getTenantDir()}/favicon.ico`
    },
    {
      rel: "canonical",
      href: url
    },
    {
      rel: "alternate",
      hreflang: item.lang,
      href: url
    }
  ]
}

export const insertScript = publicUrl => {
  const script = [
    {
      hid: "chineseAN",
      body: true,
      innerHTML: `
        function getParameterByName(a){
          var hashParams = location.hash? location.hash.split('?')[1]: '';
          var params = location.search? location.search:'?'+hashParams;
          return(a=params.match(new RegExp("[?\x26]"+a+"\x3D([^\x26]*)(\x26?)","i")))?a[1]:a
        }
        var txid = getParameterByName('txId');
        if (txid&&!/[^a-z0-9]/.test(txid)) {
          txid = txid.length>13?txid.substring(0, 13):txid;
          var date = new Date();
          date.setTime(date.getTime()+ 2592000 * 100000);
          var expirationTime = date.toUTCString();
          document.cookie = "txid=" + txid + "; expires=" + expirationTime + "; path=/; domain=." + location.hostname.replace(/^www\./i, "");
        }
      `
    },
    {
      hid: "easychat",
      src: "https://chat-plugin.easychat.co/easychat.js",
      type: "text/javascript",
      body: true,
      async: true,
      charset: "utf-8"
    }
  ]
  const noScript = []
  return {
    script,
    noScript
  }
}

const FACEBOOK_PIXEL_ID = {
  0: "182701316148340",
  15: "303964103556776"
}
export const generatorScriptByTenantId = () => {
  const { VUE_APP_PUBLIC_PATH } = process.env
  const tenantId = getTenantId()
  const publicUrl = VUE_APP_PUBLIC_PATH
  const script = [
    {
      hid: "facebook",
      body: true,
      innerHTML: `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${FACEBOOK_PIXEL_ID[tenantId]}');
        fbq('track', 'PageView');
      `
    },
    {
      hid: "omnichat",
      src: `${publicUrl}/public/${getTenantDir()}/omnichat.js`,
      type: "text/javascript",
      body: true,
      async: true,
      charset: "utf-8"
    }
  ]
  const noScript = [
    {
      hid: "noScript",
      body: true,
      innerHTML: `
        <img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=${FACEBOOK_PIXEL_ID[tenantId]}&ev=PageView&noscript=1"
        />
      `
    }
  ]
  return {
    script,
    noScript
  }
}

export const getStyle = function () {
  const tenantId = getTenantId()
  // tenantId wellcome is 15 , MPJ is 0
  // console.log("==== getStyle tenantId ===", tenantId)
  let style = ""
  if (tenantId == "15") {
    style = `{
      --brand-50: #FFF8F8;
      --brand-100: #FFE8E8;
      --brand-200: #FCC7C1;
      --brand-300: #FF6D68;
      --brand-400: #FF4D51;
      --brand-500: #E40032;
      --brand-700: #8F001C;
      --primary-50: #FFF8F8;
      --primary-100: #FFE8E8;
      --primary-200: #FCC7C1;
      --primary-300: #FF6D68;
      --primary-400: #FF4D51;
      --primary-500: #E40032;
      --primary-700: #8F001C;
      --secondary-50: #FFFCF4;
      --secondary-100: #FFF5CC;
      --secondary-150: #FCEDB5;
      --secondary-200: #FFEC99;
      --secondary-400: #FFE266;
      --secondary-500: #FFCF00;
      --secondary-700: #B39100;
      --delivery-background: var(--primary-700);
      --progress-define-back: #E5E5E5;
      --progress-success: #46A147;
      --cart-background:var(--secondary-500);
      --cart-color: #000;
      --odrer-byAgainColor-color:#000;
      --delivery-count-color: var(--secondary-500);
      --add-to-cart-color: #000000;
      --add-to-cart-background: var(--primary-100);
    }`
  } else if (tenantId == "0") {
    style = `{
      --brand-50: #F9F9F9;
      --brand-100: #E8E8E8;
      --brand-200: #B8B8B8;
      --brand-300: #666666;
      --brand-400: #494948;
      --brand-500: #1B1B1A;
      --brand-700: #131312;
      --primary-50: #F9FCF3;
      --primary-100: #ECF6D7;
      --primary-150: #FCEDB5;
      --primary-200: #B6CDBE;
      --primary-400: #447D57;
      --primary-500: #155D2D;
      --primary-700: #0F4220;
      --secondary-50: #FFFCF4;
      --secondary-100: #FFF5CC;
      --secondary-150: #FCEDB5;
      --secondary-200: #FFEC99;
      --secondary-400: #FFE266;
      --secondary-500: #FFCF00;
      --secondary-700: #B39100;
      --delivery-background: var(--brand-400);
      --progress-define-back: #E5E5E5;
      --progress-success: #46A147;
      --cart-background:#CC2B1E;
      --cart-color: var(--brand-50);
      --odrer-byAgainColor-color: var(--primary-500);
      --delivery-count-color: var(--progress-success);
      --add-to-cart-color: #ffffff;
      --add-to-cart-background: var(--primary-500);
    }`
  }
  return [
    {
      cssText: `:root ${style};`,
      type: "text/css"
    }
  ]
}
// 获取:root color
export const getRootStyle = function () {
  const root = document.querySelector(":root")
  const primaryColor = getComputedStyle(root).getPropertyValue("--primary-500")
  const brand500 = getComputedStyle(root).getPropertyValue("--brand-500")
  const progressSuccessColor = getComputedStyle(root).getPropertyValue("--progress-success")
  const primary100 = getComputedStyle(root).getPropertyValue("--primary-100")
  const odrerByAgainColor = getComputedStyle(root).getPropertyValue("--odrer-byAgainColor-color")
  return {
    primaryColor,
    brand500,
    progressSuccessColor,
    primary100,
    odrerByAgainColor
  }
}

export const getCommonHead = () => {
  return {
    style: getStyle(),
    script: generatorScriptByTenantId().script,
    noscript: generatorScriptByTenantId().noScript,
    __dangerouslyDisableSanitizers: ["script", "noscript"]
  }
}
